import React, { useContext } from "react";
import FilterBar from "./FilterBar";
import MobileSubNav from "./MobileSubNav";
import NavContext from "contexts/NavContext";

const BoardNavigationButtons = [
	// { name: "All", link: "/publications/books/all" },

	{ name: "Current AAPL Board", link: "/about/board" },
	{ name: "Invitation", link: "/about/board/apply" },
	{ name: "Qualifications & Commitments", link: "/about/board/areas-of-expertise" },
	{ name: "Apply", link: "https://www.surveymonkey.com/r/DS85PK8" },
	{ name: "Nominate Someone", link: "https://www.surveymonkey.com/r/RDY3K7L" },
];

BoardNavigationButtons.title = "2025 AAPL Board Application";

const Desktop = ({ megaNavName, userDropdownOpen }) => {
	const { scrollHeaderLimit } = useContext(NavContext);

	return (
		<FilterBar
			isSlimNav={scrollHeaderLimit}
			filterButtons={BoardNavigationButtons}
			hideAssessment={true}
			subNavScroll={0}
			isMiniSiteSubNav={true}
			className={megaNavName || userDropdownOpen ? "z-index-neg-1" : ""} //this class is made global in Layout.js
			withScroll={true}
			navIgnore="/about"
		/>
	);
};

const Mobile = () => {
	return <MobileSubNav withScroll={true} subNavScroll={0} navigation={BoardNavigationButtons} />;
};
//Sub navs
export default {
	Mobile: Mobile,
	Desktop: Desktop,
};
